import React from 'react'
import clients_routes from './views/clients/_routes'
import partners_routes from './views/partners/_routes'
import suppliers_routes from './views/suppliers/_routes'
import products_routes from './views/products/_routes'

import _modules from '../../_modules'

const PurchaseOrders = React.lazy(() => import('./views/purchaseOrders/PurchaseOrders'))
const PurchaseOrdersDetail = React.lazy(() => import('./views/purchaseOrders/PurchaseOrdersDetail'))
const PurchaseOrdersVersions = React.lazy(() =>
  import('./views/purchaseOrders/PurchaseOrdersVersions'),
)
const SalesOrders = React.lazy(() => import('./views/salesOrders/SalesOrders'))
const SalesOrdersDetail = React.lazy(() => import('./views/salesOrders/SalesOrdersDetail'))
const SalesOrdersVersions = React.lazy(() => import('./views/salesOrders/SalesOrdersVersions'))
const SalesQuotations = React.lazy(() => import('./views/salesQuotations/SalesQuotations'))
const SalesQuotationsDetail = React.lazy(() =>
  import('./views/salesQuotations/SalesQuotationsDetail'),
)
const SalesQuotationsVersions = React.lazy(() =>
  import('./views/salesQuotations/SalesQuotationsVersions'),
)
const SalesInvoices = React.lazy(() => import('./views/salesInvoices/SalesInvoices'))
const SalesInvoicesDetail = React.lazy(() => import('./views/salesInvoices/SalesInvoicesDetail'))
const SalesInvoicesVersions = React.lazy(() =>
  import('./views/salesInvoices/SalesInvoicesVersions'),
)
const SalesReceipts = React.lazy(() => import('./views/salesReceipts/SalesReceipts'))
const SalesReceiptsDetail = React.lazy(() => import('./views/salesReceipts/SalesReceiptsDetail'))
const SalesReceiptsVersions = React.lazy(() =>
  import('./views/salesReceipts/SalesReceiptsVersions'),
)
const Contracts = React.lazy(() => import('./views/contracts/Contracts'))
const ContractsDetail = React.lazy(() => import('./views/contracts/ContractsDetail'))

const ReturnsDetail = React.lazy(() => import('../trading/views/returns/ReturnsDetail'))
const Returns = React.lazy(() => import('../trading/views/returns/Returns'))

const Commissions = React.lazy(() => import('./views/commissions/Commissions'))
const CommissionsDetail = React.lazy(() => import('./views/commissions/CommissionsDetail'))

const TermsAndConditions = React.lazy(() => import('./views/termsAndConditions/TermsAndConditions'))
const TermsAndConditionsDetail = React.lazy(() =>
  import('./views/termsAndConditions/TermsAndConditionsDetail'),
)

const SalesInvoicesChart = React.lazy(() => import('./views/salesInvoicesChart/SalesInvoicesChart'))

let _routes = []

if (_modules.purchase_orders)
  _routes.push(
    ...[
      {
        path: '/purchase-orders/:id/versions',
        name: 'Purchase Order Versions',
        component: PurchaseOrdersVersions,
      },
      {
        path: '/purchase-orders/:id',
        name: 'Purchase Order Detail',
        component: PurchaseOrdersDetail,
      },
      { path: '/purchase-orders', name: 'Purchase Orders', component: PurchaseOrders },
    ],
  )
if (_modules.sales_orders)
  _routes.push(
    ...[
      {
        path: '/sales-orders/:id/versions',
        name: 'Sales Order Versions',
        component: SalesOrdersVersions,
      },
      {
        path: '/sales-orders/:id',
        name: 'Sales Order Detail',
        component: SalesOrdersDetail,
      },
      { path: '/sales-orders', name: 'Sales Orders', component: SalesOrders },
    ],
  )
if (_modules.sales_quotations)
  _routes.push(
    ...[
      {
        path: '/sales-quotations/:id/versions',
        name: 'Sales Quotation Versions',
        component: SalesQuotationsVersions,
      },
      {
        path: '/sales-quotations/:id',
        name: 'Sales Quotation Detail',
        component: SalesQuotationsDetail,
      },
      { path: '/sales-quotations', name: 'Sales Quotations', component: SalesQuotations },
    ],
  )
if (_modules.sales_invoices)
  _routes.push(
    ...[
      {
        path: '/sales-invoices/:id/versions',
        name: 'Sales Invoice Versions',
        component: SalesInvoicesVersions,
      },
      {
        path: '/sales-invoices/:id',
        name: 'Sales Invoice Detail',
        component: SalesInvoicesDetail,
      },
      { path: '/sales-invoices', name: 'Sales Invoices', component: SalesInvoices },
    ],
  )
if (_modules.sales_receipts)
  _routes.push(
    ...[
      {
        path: '/sales-receipts/:id/versions',
        name: 'Sales Receipt Versions',
        component: SalesReceiptsVersions,
      },
      {
        path: '/sales-receipts/:id',
        name: 'Sales Receipt Detail',
        component: SalesReceiptsDetail,
      },
      { path: '/sales-receipts', name: 'Sales Receipts', component: SalesReceipts },
    ],
  )
if (_modules.contracts)
  _routes.push(
    ...[
      {
        path: '/contracts/:id',
        name: 'Contract Detail',
        component: ContractsDetail,
      },
      { path: '/contracts', name: 'Contracts', component: Contracts },
    ],
  )
if (_modules.returns)
  _routes.push(
    ...[
      {
        path: '/returns/:id',
        name: 'Return Detail',
        component: ReturnsDetail,
      },
      { path: '/returns', name: 'Returns', component: Returns },
    ],
  )
if (_modules.commissions)
  _routes.push(
    ...[
      { path: '/commissions/:id', name: 'Clients Commissions', component: CommissionsDetail },
      { path: '/commissions', name: 'Commissions', component: Commissions },
    ],
  )

if (_modules.terms_and_conditions)
  _routes.push(
    ...[
      {
        path: '/terms-and-conditions/:id',
        name: 'Terms and Condition Detail',
        component: TermsAndConditionsDetail,
      },
      {
        path: '/terms-and-conditions',
        name: 'Terms and Conditions',
        component: TermsAndConditions,
      },
    ],
  )

if (_modules.sales_invoices_chart)
  _routes.push(
    ...[
      {
        path: '/sales-invoices-chart',
        name: 'Sales Invoices Chart',
        component: SalesInvoicesChart,
      },
    ],
  )

_routes = _routes.concat(clients_routes) // Clients
_routes = _routes.concat(partners_routes) // Partners
_routes = _routes.concat(suppliers_routes) // Suppliers
_routes = _routes.concat(products_routes) // Products

export default _routes
